import { viewerBackground } from '@/theme/colors';
import { Box, Button, IconButton } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const ParentContainer = muiStyled(Box)<{ navbarHeight: number }>(({ navbarHeight }) => ({
  paddingTop: navbarHeight,
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  height: 'calc(100vh / var(--zoom))',
  background: viewerBackground,
  overflow: 'hidden',
}));

export const OutlinedButton = muiStyled(Button)({
  border: '2px solid #fff',
  color: '#fff',
  '&:hover': {
    border: '2px solid #fff',
  },
});

export const OutlinedIconButton = muiStyled(IconButton)({
  border: '2px solid #fff',
  borderRadius: '4px',
  padding: '4px',
  marginLeft: '10px',
  ':hover': {
    background: 'inherit',
    border: '2px solid #fff',
  },
});
